import React from 'react';
import { useTranslation } from 'react-i18next';
import './contactOptionsComponent.css';

const ContactWay = ({ selectedContactWay, setSelectedContactWay }) => {
    const { t } = useTranslation();
    const contactOptions = [
        {
            text: "EMAIL",
            value: "1"
        },
        {
            text: "FORM_NAME_PHONE",
            value: "2"
        },
        {
            text: "BOTH",
            value: "3"
        }
    ]
    return (
        <div className='contactWayMainContainer'>
            <p>{t('CONTACT_WAY')}*</p>
            <div className='contactWayOptions'>
                {contactOptions.map((option) => (
                    <p className='contactWayOption' key={option.value} onClick={() => setSelectedContactWay(option.value)}>
                        <input
                            className='contactWayInput'
                            type="radio"
                            name="contactWay"
                            id={`contactWay-${option.value}`}
                            checked={selectedContactWay === option.value}
                            onChange={() => setSelectedContactWay(option.value)}
                        />
                        <label className='contactWayLabel' htmlFor={`contactWay-${option.value}`}>{t(option.text)}</label>
                    </p>
                ))}
            </div>
        </div>
    );
};

export default ContactWay;
